import userInteraction from './user-interaction.directive'
import businessLogService from './business-log.service'

const module = angular.module('ac.components.business-log', [])

module.factory('businessLogService', businessLogService).directive('userInteraction', userInteraction)

export default module.name
